/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for sentimentType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="sentimentType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="POSITIVE"/&gt; &lt;enumeration value="NEUTRAL"/&gt; &lt;enumeration value="NEGATIVE"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class SentimentType extends Enum{

	static  POSITIVE = SentimentType.newLiteral("POSITIVE");

	static  NEUTRAL = SentimentType.newLiteral("NEUTRAL");

	static  NEGATIVE = SentimentType.newLiteral("NEGATIVE");



	value() {
		return this.name();
	}

	static fromValue(v) {
		return SentimentType.valueOf(v);
	}

	getResourceId() {
		return (("SentimentType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/SentimentType.js